import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { ReportsService } from '../services/reports.service';

@Injectable({ providedIn: 'root' })
export class ProfileInsightPageResolver implements Resolve<any> {
  constructor(private rptService: ReportsService) {}

  resolve(): Observable<any> {
    return this.rptService.profileInsightForkJoined();
  }
}
